<template>
    <div class="gotop-btn" :style="{background: themeColor}" @click="gotop">     
            <img src="@/assets/gotop.png"/>        
    </div>
</template>

<script>
    export default {
        computed: {
            themeColor () {
                return this.$store.state.themeColor
            }
        },
        methods: {
            gotop () {
                window.scrollTo({ 
                    top: 0, 
                    behavior: "smooth" 
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .gotop-btn{
        position: fixed;
        right: 20px;
        bottom: 100px;
        padding: 7px;
        box-sizing: border-box;
        width: 40px;
        height: 40px;
        border-radius: 5px;
        opacity:0.6;
        img{
            width: 100%;
            height: 100%;         
        }
    }
    .gotop-btn:hover{
        opacity: 1;
    }
</style>
